import {
  IonButton,
  IonButtons,
  IonCheckbox,
  IonContent,
  IonFooter,
  IonHeader,
  IonIcon,
  IonItem,
  IonLabel,
  IonList,
  IonListHeader,
  IonModal,
  IonTitle,
  IonToolbar,
} from "@ionic/react";
import { closeOutline } from "ionicons/icons";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  FilterFileTypes,
  setDisabledFilter,
  setEnabledFilter,
  setFilterList,
  setFilterModal,
  setIsSignableFilter,
  setNotSignableFilter
} from "../../../store/fileTypes";
import { RootState } from "../../../store/rootReducer";

const optionList = [
  { name: "Para firmar", checked: false },
  { name: "No firmables", checked: false },
  { name: "Activos", checked: false },
  { name: "Inactivos", checked: false }] as FilterFileTypes[];

export const FilterSelector: React.FC = () => {
  const dispatch = useDispatch();

  const filterList = useSelector((state: RootState) => state.fileTypes.filterList);
  const showModal = useSelector((state: RootState) => state.fileTypes.filterModal);

  const [filterFormData, setFilterFormData] = useState<FilterFileTypes[]>([]);

  const initFormData = () => {
    setFilterFormData(
      optionList.map((option) => ({
        ...option,
        checked: !!filterList?.find((element) => element.name === option.name),
      }))
    );
  };

  const handleCheck = (filterChecked: FilterFileTypes) => {
    setFilterFormData(
      filterFormData.map((filterItem) => ({
        ...filterItem,
        checked: filterChecked === filterItem ? !filterItem.checked : filterItem.checked,
      }))
    );
  };

  const applyFilter = () => {
    dispatch(setFilterList(filterFormData.filter(({ checked }) => checked)));

    filterFormData.map(value => {
      switch (value.name) {
        case "Para firmar":
          dispatch(setIsSignableFilter(value.checked));
          break;
        case "No firmables":
          dispatch(setNotSignableFilter(value.checked));
          break;
        case "Activos":
          dispatch(setEnabledFilter(value.checked));
          break;
        case "Inactivos":
          dispatch(setDisabledFilter(value.checked));
          break;
        default:
          break;
      }
    })
    dispatch(setFilterModal(false));
  };

  const resetFilter = () => {
    dispatch(setFilterList([]));
    setFilterFormData([]);
    dispatch(setIsSignableFilter(true));
    dispatch(setNotSignableFilter(true));
    dispatch(setEnabledFilter(true));
    dispatch(setDisabledFilter(true));

    dispatch(setFilterModal(false));

  };

  return (
    <>
      <IonModal
        isOpen={showModal}
        onWillPresent={initFormData}
        onDidDismiss={() => dispatch(setFilterModal(false))}
      >
        <IonHeader>
          <IonToolbar>
            <IonTitle>Filtrar tipos de documentos</IonTitle>
            <IonButtons slot="end">
              <IonButton onClick={() => dispatch(setFilterModal(false))}>
                <IonIcon icon={closeOutline} />
              </IonButton>
            </IonButtons>
          </IonToolbar>
        </IonHeader>
        <IonContent>
          <IonList>
            <IonListHeader>Filtrar por:</IonListHeader>
            {filterFormData.map((filterItem: FilterFileTypes, index: number) => (
              <IonItem key={index}>
                <IonLabel>{filterItem.name}</IonLabel>
                <IonCheckbox
                  slot="end"
                  checked={filterItem.checked}
                  onIonChange={() => handleCheck(filterItem)}
                />
              </IonItem>
            ))}
          </IonList>
        </IonContent>
        <IonFooter>
          <IonToolbar color="light">
            <IonButtons slot="end">
              <IonButton color="danger" fill="solid" onClick={resetFilter}>
                Limpiar filtro
              </IonButton>
              <IonButton color="primary" fill="solid" onClick={applyFilter}>
                Aplicar filtro
              </IonButton>
            </IonButtons>
          </IonToolbar>
        </IonFooter>
      </IonModal>
    </>
  );
};
